package com.devsusana.portfolio.models

/**
 * Represents a professional experience milestone.
 */
data class Experience(
    val role: String,
    val company: String,
    val period: String,
    val summary: String,
    val highlights: List<String>,
    val technologies: List<String>
)
